import React from 'react';

import DeviceSubtypeIcon from 'app/components/device/DeviceSubtypeIcon';
import { Text, Icon, Box, Flex } from 'core/components';
import ResultMenuItem from './ResultMenuItem';

function Device({ item, selected, query, onItemClick, ...rest }) {
  const { id, path, device_name, device_subtype, sending_ips_base } = item;
  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'device', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <DeviceSubtypeIcon iconSize={22} type={device_subtype} />
      </Flex>

      <Box gridArea="title">
        <Text className="title">{device_name}</Text>
      </Box>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>

      <Text
        className="description"
        gridArea="description"
        muted
        small
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        style={{ overflow: 'hidden' }}
      >
        {device_subtype}
        {sending_ips_base}
      </Text>
    </ResultMenuItem>
  );
}

export default Device;
